import { Injectable } from "@angular/core";
import { RowTable } from "@shared/schemas/row-table";
import { Subject } from "rxjs";

@Injectable()
export class TableCheckboxService {
	private _selectedElement = new Subject<unknown>();
	selectedElement$ = this._selectedElement.asObservable();

	private _checkAll = new Subject<boolean>();
	checkAll$ = this._checkAll.asObservable();

	private _checkAllDt = new Subject<boolean>();
	checkAllDt$ = this._checkAllDt.asObservable();

	private _selection = new Subject<RowTable[]>();
	selection$ = this._selection.asObservable();

	newElement(element: unknown): void {
		this._selectedElement.next(element);
	}

	setStatusCheckAll(status: boolean): void {
		this._checkAll.next(status);
	}

	setCheckAllDt(status: boolean): void {
		this._checkAllDt.next(status);
	}

	setSelection(selection: RowTable[]) {
		this._selection.next(selection);
	}
}
